import React from 'react';
import { AtSign, Voicemail, Instagram, Linkedin } from 'react-feather';
import { DataLink, SectionTitle } from '../../components';
import { updateMetaInfo } from '../../utils';

const description = 'Here is the contact information for Ather.';

const Contact = () => (
  <div className="contact-area section padding-top padding-bottom">
    {updateMetaInfo(description)}
    <div className="container">
      <SectionTitle title="Contact Me" />
      <div className="row">
        <div className="col-lg-12">
          <h2>The &quot;Professional&quot; Way</h2>
          <div className="contact-info row">
            <div className="contact-infoblock col-md-4 col-sm-12">
              <div className="contact-infoblock-icon">
                <AtSign />
              </div>
              <div className="contact-infoblock-content">
                <p>
                  <DataLink to="mailto:ather.sharif@gmail.com">
                    ather.sharif at gmail
                  </DataLink>
                </p>
                <p className="note">
                  I want to think I have a pretty decent spam filter. But still,
                  don&apos;t spam. To-the-point subject lines get faster
                  responses.
                </p>
              </div>
            </div>
            <div className="contact-infoblock col-md-4 col-sm-12">
              <span className="contact-infoblock-icon">
                <Voicemail />
              </span>
              <div className="contact-infoblock-content">
                <p>
                  <DataLink to="tel:1-267-788-0898">+1 267-788-0898</DataLink>
                </p>
                <p className="note">
                  I usually never pick up calls from an unknown number. Please
                  leave a voicemail. Usually on Eastern Time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <h2>The &quot;Millenial&quot; Way</h2>
          <div className="contact-info row">
            <div className="contact-infoblock col-md-4 col-sm-12">
              <span className="contact-infoblock-icon">
                <Linkedin />
              </span>
              <div className="contact-infoblock-content">
                <p>
                  <DataLink to="https://www.linkedin.com/in/athersharif/">
                    athersharif
                  </DataLink>
                </p>
              </div>
            </div>
            <div className="contact-infoblock col-md-4 col-sm-12">
              <span className="contact-infoblock-icon">
                <Instagram />
              </span>
              <div className="contact-infoblock-content">
                <p>
                  <DataLink to="https://www.instagram.com/1000001_01110011/">
                    1000001_01110011
                  </DataLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
